import type { ArmyPaint } from '../../../lib/core/ArmyPainter/ArmyPaint.type'
import { armyPaintDisk } from '../../../lib/core/disk/IndexedDBDisk'
import {
  EXPORT_DISK_PLACEHOLDER_ERROR,
  StateMapDisk,
  WORKSPACE_DISK_PLACEHOLDER_ERROR,
} from '../../../lib/core/state/state_map_disk.enum'
import { backendAxios } from '../../../axios'
import { getAuthArmyPaint, setAuthArmyPaint } from './AuthArmyPaintSignal'
import { hasIndexedDB } from '../../../lib/core/Storage/IndexedDB/hasIndexedDB'

export default async function saveArmyPaintToDisk(ap: ArmyPaint) {
  if (ap.disk === StateMapDisk.IndexedDB) {
    if (!hasIndexedDB()) {
      throw new Error('IndexedDB requested but not available')
    }
    await armyPaintDisk.save(ap)
  } else if (ap.disk === StateMapDisk.Cloud) {
    // Backend assigns ID, but we assume it's a POST to /st1/army-paint
    // If it has an ID, it's an update, otherwise create.
    const response = ap.id > 100000 // assuming IDs > 100000 are already from server or similar logic
        ? await backendAxios.post(`/st1/army-paint/${ap.id}`, ap)
        : await backendAxios.post('/st1/army-paint', ap)

    // Update the AP with the response from server (e.g. assigned ID)
    ap = { ...ap, ...response.data }
  } else if (ap.disk === StateMapDisk.Export) {
    throw new Error(EXPORT_DISK_PLACEHOLDER_ERROR)
  } else if (ap.disk === StateMapDisk.Workspace) {
    throw new Error(WORKSPACE_DISK_PLACEHOLDER_ERROR)
  } else {
    throw new Error('Invalid disk: ' + ap.disk)
  }

  // Update selected if it's the same one
  if (getAuthArmyPaint()?.id === ap.id) {
    setAuthArmyPaint(ap)
  }
}
